import React from 'react';
import { styled } from '@mui/material/styles';
import {
    Box,
    Button,
    FormControl,
    FormControlLabel,
    InputAdornment,
    InputLabel,
    OutlinedInput,
    Switch,
} from '@mui/material';


const CustomSwitch = styled(Switch)({
    '& .MuiSwitch-switchBase': {
        color: 'rgba(207, 235, 200, 1)',
        '&:hover': {
            backgroundColor: 'rgba(255, 255, 255, 0.1)',
        },
    },
    '& .MuiSwitch-switchBase.Mui-checked': {
        color: 'rgba(178, 235, 177, 1)',
        '&:hover': {
            backgroundColor: 'rgba(178, 235, 177, 0.1)',
        },
    },
    '& .MuiSwitch-switchBase + .MuiSwitch-track': {
        backgroundColor: 'rgba(255, 255, 255, 0.5)'
    },
    '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
        backgroundColor: 'rgba(178, 235, 177, 1)'
    },
    '& .MuiSwitch-thumb': {
        backgroundColor: 'rgba(178, 235, 177, 1)'
    }
})

const CustomOutline = styled(OutlinedInput)({
    '&.Mui-disabled':{
        '& .MuiOutlinedInput-notchedOutline': {
            borderWidth: 1,
            borderStyle: 'solid',
            borderColor: 'rgba(139, 142, 146, 1)'
        },
        '& .MuiOutlinedInput-input': {
            borderWidth: 1,
            borderStyle: 'solid',
            borderColor: 'rgba(139, 142, 146, 1)',
            borderTopLeftRadius: 4,
            borderBottomLeftRadius: 4
        }
    },
    '&:hover': {
        '& .MuiOutlinedInput-notchedOutline': {
            borderWidth: 2,
            borderColor: 'rgba(255, 255, 255, 0.7)',
        },
        '& .MuiOutlinedInput-input': {
            borderRightWidth: 2,
            borderRightStyle: 'solid',
            borderRightColor: 'rgba(255, 255, 255, 0.7)',
        }
    }
})

const CustomLabel = styled(InputLabel)({
    fontSize: '12px',
    color: 'rgba(178, 235, 177, 1)',
    marginTop: '3px'
})

const CustomFormControlLabel = styled(FormControlLabel)({
    '& .MuiFormControlLabel-label': {
        color: 'rgba(255, 255, 255, 1)',
        fontSize: '10px',
        pointerEvents: 'none',
    }
})


export default function ExpandedSwitch(props) {

    const { label, onChange, value, checked} = props

    return (
        <React.Fragment>
            <Box display="flex"
                alignContent="flex-start"
                flexDirection="column"
                flexWrap="wrap"
                width="auto"
                m={1}>
                <Box width="250px">
                    <FormControl>
                        <CustomLabel>
                            {label}
                        </CustomLabel>
                        <CustomOutline
                            onMouseDown={(event) => {
                                event.stopPropagation()
                                event.preventDefault()
                            }}
                            disabled
                            notched
                            endAdornment={
                                <CustomFormControlLabel
                                    label={value || ''}
                                    labelPlacement='bottom'
                                    control={
                                        <CustomSwitch
                                            inputProps={{ 'aria-label': 'controlled' }} 
                                            checked={checked}
                                            onChange={onChange}
                                        />
                                    }
                                />
                            }
                        />
                    </FormControl>
                </Box>
            </Box>
        </React.Fragment>
    );
}
